import { useMemo } from "react"
import { userClient, userClientAdvanced } from "./App"
import { Domicilio } from "Interfaces/Domicilio"
import { useCancel } from "BankSAHooks"
import { PedidoGuia } from "Interfaces/PedidoGuia"
import { LoteBusqueda, LoteBusquedaPaginado, LoteBusquedaResultado } from "Interfaces/LoteBusqueda"

export function useApi() {
    const cancel = useCancel()

    return useMemo(() => ({

        getDespachantesUsuario: async () => {
            const { data } = await userClient.get("/Login/GetDespachantes")
            return data
        },

        getDomiciliosUsuario: async () => {
            const { data } = await userClient.get("/UsuarioDomicilio/Domicilios")
            return data
        },

        getDespachanteData: async (CuitDespachante: string) => {
            const { data } = await userClient.get(
                "/Depachantes/Despachante",
                {
                    params: {
                        Cuit: CuitDespachante
                    }
                }
            )
            return data
        },

        getSucursalesProvincias: async () => {
            const { data } = await userClient.get(
                "/SucursarlesAndreani/Provincias",
            )
            return data
        },

        getSucursalesLocalidades: async (Provincia: string) => {
            const { data } = await userClient.get(
                "/SucursarlesAndreani/Localidad",
                {
                    params: {
                        Provincia: Provincia
                    }
                }
            )
            return data
        },

        getSucursalesAndreani: async (Provincia: string, Localidad: string) => {
            const { data } = await userClient.post(
                "/SucursarlesAndreani/BuscarSurcursales",
                {
                    "provincia": Provincia,
                    "localidad": Localidad
                }
            )
            return data
        },

        anularLote: async (bodyAnularLote: {
            "nroLote": number,
            "hash": string
        }) => {
            const { data } = await userClient.post(
                "/PedidoGuia/AnularLote", bodyAnularLote)
            return data
        },

        getEmailUsuario: async () => {
            const { data } = await userClient.get("/login/GetEmail")
            return data
        },

        agregarPedidoDigitalizacion: async (body: PedidoGuia) => {
            const { data } = await userClient.post(
                "/PedidoGuia/AgregarPedidoDigitalizacion", body
            )
            return data
        },
        generarImpresionLotes: async (body: [number]) => {
            const { data } = await userClient.post(
                "/PedidoGuia/ImpresionLotes", body
            )
            return data
        },
        updateDomicilio: async (domicilio: any) => {
            const { data } = await userClient.post(
                "/UsuarioDomicilio/UpdateUsuarioDomicilio",
                domicilio
            )
            return data
        },

        createDomicilio: async (domicilio: Domicilio) => {
            const { data } = await userClient.post(
                "/UsuarioDomicilio/InsertUsuarioDomicilio",
                domicilio
            )
            return data
        },

        deleteDomicilio: async (idDomicilio: string) => {
            const { data } = await userClient.delete(
                "/UsuarioDomicilio/DeleteDomicilio",
                {
                    params: {
                        id: idDomicilio
                    }
                }
            )
            return data
        },

        getLotesBusqueda: async (bodyLotes: LoteBusqueda) => {
            const { data } = await userClient.post(
                "/PedidoGuia/LotesBusqueda", bodyLotes
            )
            return data
        },

        getLotesBusquedaPaginado: async (bodyLotes: LoteBusquedaPaginado) => {
            const { data } = await userClient.post(
                "/PedidoGuia/LotesBusquedaPaginado", bodyLotes
            )
            return data as LoteBusquedaResultado
        },

        getBusquedaPedidoGuia: async (bodyPedidoGuia: any) => {
            const { data } = await userClient.post(
                "/PedidoGuia/BusquedaListaDespachoEndo", bodyPedidoGuia
            )
            return data
        },

        getBusquedaPedidoGuiaExcel: async (bodyPedidoGuia: any) => {
            const { data } = await userClient.post(
                "/PedidoGuia/BusquedaListaDespachosExcel", bodyPedidoGuia
            )
            return data
        },

        obtenerEmailsUsuario: async () => {
            const { data } = await userClient.get(
                "/Login/GetEmailsCargadosUsuario",
                { cancelToken: cancel.getCancelToken() }
            )
            return data
        },

        setearEmailsUsuario: async (emailUsuario: string) => {
            const { data } = await userClient.post(
                "/Login/SetearEmail",
                { email: emailUsuario }
            )
            return data
        },

        recuperarPassword: async (emailUsuario: string) => {
            const { data } = await userClient.get(
                `/Login/RecuperarPassword?usuario=${emailUsuario}`
            )
            return data
        },

        cambiarPassword: async (bodyCambiarPass: {
            "usuario": string,
            "password": string
        }) => {
            return userClient.post("/Login/CambiarContraseña", bodyCambiarPass)
        },

        obtenerEstadoDespacho: async (body: any) => {
            const { data } = await userClient.post(
                "/Ws/ObtenerEstadoDespacho", body)
            return data
        },

        obtenerListadoUnidadNegocio: async (CuitDespachante: string) => {
            const { data } = await userClient.get(
                "/PedidoGuia/UnidadesDeNegocio",
                {
                    params: {
                        CuitDespachante: CuitDespachante
                    }
                })
            return data
        },

        obtenerSucursalCorreo: async (CodigoSucursalCorreo: string) => {
            const { data } = await userClient.get(
                `/SucursarlesAndreani/BuscarSurcursal?CodigoSucursalCorreo=${CodigoSucursalCorreo}`,)
            return data
        },

        obtenerListadoTiposDeLote: async () => {
            const { data } = await userClient.get(
                "/PedidoGuia/Tramites")
            return data
        },

        getCanales: async () => {
            const { data } = await userClient.get(
                "/DepositarioFiel/GetCanales"
            );

            return data;
        },

        getTramites: async (canal: string) => {
            const { data } = await userClient.get(
                "/DepositarioFiel/GetTramitesXCanal",
                {
                    params: {
                        canal
                    }
                }
            );

            return data;
        },

        getFamilias: async (tramite: string) => {
            const { data } = await userClient.get(
                "/DepositarioFiel/GetFamiliasXTramite",
                {
                    params: {
                        tramite
                    }
                }
            );

            return data;
        },

        getSecuencias: async (
            canal: string,
            tramite: string
        ) => {
            const { data } = await userClient.get(
                "/DepositarioFiel/GetSecuenciaPorFamiliayTramite",
                {
                    params: {
                        canal,
                        tramite
                    }
                }
            );

            return data;
        },

        getCamposHabilitados: async (body: any) => {
            const { data } = await userClient.post(
                "/DepositarioFiel/CamposHabilitados",
                body
            );

            return data;
        },

        validarCampos: async (body: any) => {
            const { data } = await userClient.post(
                "/DepositarioFiel/ValidarCampos",
                body
            );

            return data;
        },

        generarPDF2441: async (body: any) => {
            const response = await userClient.post(
                "/DepositarioFiel/GenerarPDF",
                body,
                {
                    responseType: "blob"
                }
            );

            return response.data;
        },
        ...cancel
    }), [cancel])
}

export function useApiAdvanced() {
    const cancel = useCancel()

    return useMemo(() => ({

        getCanales: async () => {
            const { data } = await userClientAdvanced.get(
                "/DepositarioFiel/GetCanales"
            );

            return data;
        },

        getTiposDocumentos: async () => {
            const { data } = await userClientAdvanced.get(
                "/DepositarioFiel/GetTipoDeDocumentos"
            );

            return data;
        },

        getTramites: async (canal: string) => {
            const { data } = await userClientAdvanced.get(
                "/DepositarioFiel/GetTramitesXCanal",
                {
                    params: {
                        canal
                    }
                }
            );

            return data;
        },

        getFamilias: async (tramite: string) => {
            const { data } = await userClientAdvanced.get(
                "/DepositarioFiel/GetFamiliasXTramite",
                {
                    params: {
                        tramite
                    }
                }
            );

            return data;
        },

        getSecuencias: async (
            canal: string,
            tramite: string
        ) => {
            const { data } = await userClientAdvanced.get(
                "/DepositarioFiel/GetSecuenciaPorFamiliayTramite",
                {
                    params: {
                        canal,
                        tramite
                    }
                }
            );

            return data;
        },

        getCamposHabilitados: async (body: any) => {
            const { data } = await userClientAdvanced.post(
                "/DepositarioFiel/CamposHabilitados",
                body
            );

            return data;
        },

        validarCampos: async (body: any) => {
            const { data } = await userClientAdvanced.post(
                "/DepositarioFiel/ValidarCampos",
                body
            );

            return data;
        },

        generarPDF2441: async (body: any) => {
            const response = await userClientAdvanced.post(
                "/DepositarioFiel/GenerarPDF",
                body
            );

            return response.data;
        },
        ...cancel
    }), [cancel])
}
